import React, { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/state/AppContext";
import { disablePush, enablePush, pushStatus } from "@/lib/push";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

export function PushToggle() {
  const { t } = useApp();
  const [status, setStatus] = useState("off");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    pushStatus().then(setStatus);
  }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      if (status === "on") {
        await disablePush();
        setStatus("off");
        toast.success(t("push.turnedOff"));
      } else {
        await enablePush();
        setStatus("on");
        toast.success(t("push.turnedOn"));
      }
    } catch (e) {
      const key = e?.message === "denied" ? "push.blocked" : "push.failed";
      toast.error(t(key));
      setStatus(e?.message === "denied" ? "denied" : status);
    } finally {
      setBusy(false);
    }
  };

  if (status === "unsupported")
    return (
      <p className="text-sm text-muted-foreground" data-testid="push-unsupported">
        {t("push.unsupported")}
      </p>
    );

  return (
    <div className="flex items-start justify-between gap-4" data-testid="push-toggle">
      <div>
        <p className="flex items-center gap-2 text-sm font-medium">
          <BellRing size={15} className="text-[hsl(var(--primary))]" /> {t("push.title")}
        </p>
        <p className="mt-1 max-w-md text-sm text-muted-foreground">
          {status === "denied" ? t("push.blocked") : t("push.subtitle")}
        </p>
      </div>
      {status === "denied" ? (
        <Button variant="outline" size="sm" className="rounded-full" disabled data-testid="push-blocked-btn">
          {t("push.blockedShort")}
        </Button>
      ) : (
        <Switch aria-label={t("push.title")} checked={status === "on"} disabled={busy} onCheckedChange={toggle} data-testid="push-switch" />
      )}
    </div>
  );
}
